import React from "react";

const PolicyNotice = () => {
	return (
		<>
			<p className="policy-notice">
				By continuing, you agree to Dartmouth's{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://dartgo.org/acceptable-use-policy"
				>
					Acceptable Use Policy
				</a>{" "}
				and{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://dartgo.org/data-access-policy"
				>
					Data Access Policy
				</a>
				.
			</p>
		</>
	);
};

export default PolicyNotice;
